import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-screensTypeVert",
  "use": "svg-icon-screensTypeVert-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"svg-icon-screensTypeVert\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-4-1h16v16H-4z\" /><path d=\"M0 0h8v14H0V0zm6 12H2V2h4v10z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol